import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'tab' ];

	toggle(e) {

		if (e.target.parentElement.hasAttribute('data-group-active')) {
            e.target.parentElement.removeAttribute('data-group-active');
            return;
        }

        this.tabTargets.forEach((element) => {
            if(element.hasAttribute('data-group-active')) {
                element.removeAttribute('data-group-active');
            }
        });

        const clickedKey = e.target.dataset.key;
        this.tabTargets.forEach((element) => {
            if(clickedKey == element.getAttribute('data-key')) {
                element.setAttribute('data-group-active', true);
            }
        });

        console.log('toggled');
	}
}